module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/sub-component/common/common-attach-safety/common-attach-safety.component.scss
// module id = ./src/app/seller/sub-component/common/common-attach-safety/common-attach-safety.component.scss
// module chunks = main